"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSetsErrors = void 0;
var UseCaseError_1 = require("../../../../models/concrete/UseCaseError");
exports.getSetsErrors = [
    UseCaseError_1.UseCaseError.create('problemInProcess'),
    UseCaseError_1.UseCaseError.create('notFound'),
    UseCaseError_1.UseCaseError.create('invalidData')
];
//# sourceMappingURL=getSetsErrors.js.map